import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SiteManagementSidebar from "./Sidebar";
import { Col, Container, Navbar, Row } from "react-bootstrap";
import "../../assets/css/majorybl/pages/sitemanagement.scss";
import { isXOrSmaller, scrollToTop } from "../../lib/utils";
import useBreakpoint from "../../hooks/useBreakpoint";

const SiteManagementLayout = (): React.JSX.Element => {
    const location = useLocation();
    const [navBarCollapsed, setNavBarCollapsed] = useState(false);
    const breakpoint = useBreakpoint();
    useEffect(() => {
        scrollToTop();
        setNavBarCollapsed(true);
    }, [location.pathname]);

    const toggleNavbar = () => {
        isXOrSmaller("md", breakpoint) && setNavBarCollapsed(!navBarCollapsed);
    };

    return (
        <Container
            className="py-1 py-lg-5 siteManagement"
            data-testid="siteManagementContent"
        >
            <Row>
                <Col lg={3} xl={2}>
                    <Navbar expand="lg" expanded={!navBarCollapsed}>
                        <Navbar.Toggle
                            aria-controls="basic-navbar-nav"
                            onClick={toggleNavbar}
                        />
                        {isXOrSmaller("md", breakpoint) && (
                            <Navbar.Text>
                                <h4>Menu</h4>
                            </Navbar.Text>
                        )}
                        <Navbar.Collapse>
                            <SiteManagementSidebar
                                breakpoint={breakpoint}
                                toggleNavbar={toggleNavbar}
                            />
                        </Navbar.Collapse>
                    </Navbar>
                </Col>
                <Col lg={9} xl={10}>
                    <Outlet />
                </Col>
            </Row>
        </Container>
    );
};

export default SiteManagementLayout;
